import { render, staticRenderFns } from "./NewDOrganizeEditor.vue?vue&type=template&id=39dd45e8&"
import script from "./NewDOrganizeEditor.vue?vue&type=script&lang=js&"
export * from "./NewDOrganizeEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewDOrganizeEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports